import { stylesheet } from 'typestyle';

const styles = stylesheet({
  rowWrapper: {
    borderBottom: '1px solid #757575',
    padding: '10px 0',
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
    display: 'flex',
  },
  displayFlexWrapper: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  phoneActionWrapper: {
    marginLeft: 10,
  },
  buttonWithIcon: {
    border: 'none',
    display: 'flex',
    padding: '5px 10px',
    background: 'none',
    flexDirection: 'column',
    alignItems: 'center',
  },
  phoneIcon: {
    width: 20,
    height: 20,
  }
});

export default styles;
